import * as types from "../../constants";
import * as api from "../../services/APIService";
import * as checklist from "../../services/checklistService";

const route = "api/Checklist/";

export async function rawSearch(model) {
  let response = await checklist.search(model);
  if (response.status < 400)
    return response.data;
  throw new Error(response.data);
}

export function search(model) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CHECKLIST_SEARCH_PENDING });
    return checklist
      .search(model)
      .then((response) => {
        dispatch({
          type: types.FETCH_CHECKLIST_SEARCH_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_CHECKLIST_SEARCH_ERROR });
        throw error;
      });
  };
}

export function getSchedule(model) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CHECKLISTS_PENDING });
    return checklist
      .getSchedule(model)
      .then((response) => {
        dispatch({
          type: types.FETCH_CHECKLISTS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_CHECKLISTS_ERROR });
        throw error;
      });
  };
}

export function getReports() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CHECKLIST_REPORTS_PENDING });
    return checklist
      .getReports()
      .then((response) => {
        dispatch({
          type: types.FETCH_CHECKLIST_REPORTS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_CHECKLIST_REPORTS_ERROR });
        throw error;
      });
  };
}

export function get() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CHECKLISTS_PENDING });
    return api
      .get(route)
      .then((response) => {
        dispatch({
          type: types.FETCH_CHECKLISTS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_CHECKLISTS_ERROR });
        throw error;
      });
  };
}

export function getById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_CHECKLIST_PENDING });
    return api
      .getById(route, id)
      .then((response) => {
        dispatch({
          type: types.FETCH_CHECKLIST_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_CHECKLIST_ERROR });
        throw error;
      });
  };
}
export function update(value) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_CHECKLIST_PENDING });
    return api
      .update(route, value)
      .then((response) => {
        dispatch({
          type: types.UPDATE_CHECKLIST_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_CHECKLIST_ERROR });
        throw error;
      });
  };
}

export function updateDateCompleted(value) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_CHECKLIST_PENDING });
    return checklist
      .updateDateCompleted(value)
      .then((response) => {
        dispatch({
          type: types.UPDATE_CHECKLIST_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_CHECKLIST_ERROR });
        throw error;
      });
  };
}

export function insert(value) {
  return async (dispatch) => {
    dispatch({ type: types.INSERT_CHECKLIST_PENDING });
    return api
      .insert(route, value)
      .then((response) => {
        dispatch({
          type: types.INSERT_CHECKLIST_SUCCESS,
          payload: response,
        });
        //dispatch(getLastLocation());
      })
      .catch((error) => {
        dispatch({ type: types.INSERT_CHECKLIST_ERROR });
        throw error;
      });
  };
}

export function insertSchedule(value) {
  return async (dispatch) => {
    dispatch({ type: types.INSERT_CHECKLIST_SCHEDULE_PENDING });
    return checklist
      .insertSchedule(value)
      .then((response) => {
        dispatch({
          type: types.INSERT_CHECKLIST_SCHEDULE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.INSERT_CHECKLIST_SCHEDULE_ERROR });
        throw error;
      });
  };
}

export function updateSchedule(value) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_CHECKLIST_PENDING });
    return checklist
      .updateSchedule(value)
      .then((response) => {
        dispatch({
          type: types.UPDATE_CHECKLIST_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_CHECKLIST_ERROR });
        throw error;
      });
  };
}

export function updateScheduleIndividual(value) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_CHECKLIST_PENDING });
    return checklist
      .updateScheduleIndividual(value)
      .then((response) => {
        dispatch({
          type: types.UPDATE_CHECKLIST_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_CHECKLIST_ERROR });
        throw error;
      });
  };
}

export function remove(value) {
  return async (dispatch) => {
    dispatch({ type: types.REMOVE_CHECKLIST_PENDING });
    return api
      .remove(route, value)
      .then((response) => {
        dispatch({
          type: types.REMOVE_CHECKLIST_SUCCESS,
          payload: response,
        });
        //remove redux: dispatch(get());
      })
      .catch((error) => {
        dispatch({ type: types.REMOVE_CHECKLIST_ERROR });
        throw error;
      });
  };
}

export function removeSchedule(value) {
  return async (dispatch) => {
    dispatch({ type: types.REMOVE_CHECKLIST_PENDING });
    return checklist
      .removeSchedule(value)
      .then((response) => {
        dispatch({
          type: types.REMOVE_CHECKLIST_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.REMOVE_CHECKLIST_ERROR });
        throw error;
      });
  };
}

export function updateSelectedUser(value) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_CHECKLIST_SELECTED_USER_PENDING });
    dispatch({
      type: types.UPDATE_CHECKLIST_SELECTED_USER_SUCCESS,
      payload: value,
    });
  };
}

export function getLastLocation() {
  return async (dispatch) => {
    return checklist
      .getLastLocation()
      .then((response) => {
        dispatch({
          type: types.GET_LAST_LOCATION,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: types.GET_LAST_LOCATION_ERROR });
        //as if anyone catches this crap throw error;
      });
  };
}
